import { createFileRoute } from "@tanstack/react-router";
import { VisitHistory } from "@/routes/_authenticated/_visitors/visitors/-components/visit-history";

export const Route = createFileRoute("/_authenticated/_care/residents/$residentId/visitors")({
  component: ResidentVisitorsTab,
});

/** Who has come to see this resident, newest first, straight off the sign-in sheet. */
function ResidentVisitorsTab() {
  const { residentId } = Route.useParams();
  return (
    <VisitHistory
      source={{ kind: "resident", residentId }}
      emptyTitle="No visitors recorded"
      emptyDescription="Visits appear here when somebody checks in to see this resident at the kiosk or the desk."
    />
  );
}
